import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const Minimize = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 24' {...rest}>
    {type === 'stroke' ? (
      <path
        d='M14 4.438v5a1 1 0 0 0 1 1h5m-10 10v-5a1 1 0 0 0-1-1H4m11-5 5.25-5.25M9 15.438l-5.25 5.25'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    ) : (
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M20.78 3.658a.75.75 0 0 1 0 1.06l-4.97 4.97H20a.75.75 0 0 1 0 1.5h-5a1.75 1.75 0 0 1-1.75-1.75v-5a.75.75 0 0 1 1.5 0v4.19l4.97-4.97a.75.75 0 0 1 1.06 0M3.25 14.438a.75.75 0 0 1 .75-.75h5c.966 0 1.75.784 1.75 1.75v5a.75.75 0 0 1-1.5 0v-4.19l-4.97 4.97a.75.75 0 0 1-1.06-1.06l4.97-4.97H4a.75.75 0 0 1-.75-.75'
        fill='currentColor'
      />
    )}
  </IconBase>
);
